import { createContext, useState } from 'react'

export const MessengerContext = createContext()

export const MessengerContextProvider = ({children}) => {
    
    const INITIAL_STATE = {
        conversation: {
            members: []
        },
        messages: [
            
        ],
        communicator: {
            
        },
        isFetching: false
    }
    
    const [conversation, setConversation] = useState(INITIAL_STATE)

    return (
        <MessengerContext.Provider value={[conversation, setConversation]}>
            {children}
        </MessengerContext.Provider>
    )
}